/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Elementer',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Opdateret',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'Ny',
  'company-hub.hub-element-placeholder.extension.sub-heading': 'Intet her endnu. Tænk i muligheder...',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'Se alle muligheder',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'Pladsholder til hubelement',
};
